<script lang="ts">
	import { TalksGalleryPage } from '#lib/websites/talks/pages/TalksGalleryPage/index.js';
</script>

<TalksGalleryPage />
